import React from "react";
import CalendarPicker from "../components/calendar-picker";
import Time from "../components/time";

export default function DateHoursInput({
  onSelectedDateFrom,
  value,
  is24HoursFormat,
  timeFrom,
  onSelectTimeFrom,
}) {
  return (
    <>
      <CalendarPicker
        label={"Date"}
        isStanAlone
        onSelected={(value, str) => onSelectedDateFrom(value, str)}
        value={value}
        id="date-hours-input-calendar-component"
      />
      <Time
        label={"Hours"}
        ampm={!is24HoursFormat}
        value={timeFrom}
        onChange={(value) => onSelectTimeFrom?.(value)}
        id="date-hours-input-time-component"
      />
    </>
  );
}
